import { UnifiedGraftModelTypeKey } from '@/core/const/unifiedGraftModelTypeKeys.const'

import { getUnifiedGraftModelType } from './getUnifiedGraftModelType'

const ACCESSOR_KINDS = new Set<string>([UnifiedGraftModelTypeKey.SETTER, UnifiedGraftModelTypeKey.GETTER])

/**
 * Setter/getter blobs in INSTANCE_FIELD | STATIC_FIELD | PROPERTY payloads ([NAME, TYPE_USAGE, SETTER, GETTER]).
 * They must not be passed to declaring-type / TYPE_USAGE formatters or to TypeLink.
 */
export function isAccessorMetadataNode(value: unknown): boolean {
  if (value === null || typeof value !== 'object' || !('payload' in (value as object))) {
    return false
  }

  const kind = getUnifiedGraftModelType(value as { unifiedGraftModelType?: unknown; graftModelType?: unknown })
  return ACCESSOR_KINDS.has(kind)
}
